<template>
    <div class="content" v-if="isOnline">
        <!--<div class="container">-->
            <transition name="fade">
                <router-view></router-view>
            </transition>
        <!--</div>-->
    </div>
    <offline v-else></offline>
</template>

<script>
import axios from 'axios'

    export default {
        name: '',
        data () {
            return {
                isOnline: true
            }
        },
        created () {
            this.updateStatus()
            // this.getTextFromSheets()
        },
        components: {
            'offline': require('@/components/core/offline')
        },
        methods: {
            updateStatus: function () {
                if (typeof window.navigator.onLine === 'undefined') {
                    this.isOnline = true
                } else {
                    this.isOnline = window.navigator.onLine
                }
                window.addEventListener('online', this.updateStatus)
                window.addEventListener('offline', this.updateStatus)
            },
            getTextFromSheets () {
                let url = 'https://spreadsheets.google.com/feeds/cells/1W2tundguiulkb0tRXqqzUcaQjkIJRnQ6-MlJglKxnFk/1/public/values?alt=json-in-script'
                axios
                    .get(url)
                    .then((response) => {
                        const formattedText = response.data.replace('gdata.io.handleScriptLoaded(', '').slice(0, -2)
                        const jsonText = JSON.parse(formattedText)
                        if (jsonText) {
                            this.$store.state.texts.danish = jsonText.feed.entry[1].content.$t
                            this.$store.state.texts.swedish = jsonText.feed.entry[3].content.$t
                            this.$store.state.texts.norwegian = jsonText.feed.entry[5].content.$t
                        }
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// layout.vue?f536b8c0